// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"c867ebbf","787":"7343771a"}[chunkId] + ".chunk.js";
};